'use strict';

export default function f($http, $timeout, $q, utils, modal, Storage, userModel, admin) {
  'ngInject';

  return {
    response: {},

    checkShow: function () {
      return new $q((resolve) => {
        if (admin.isAdmin()) {
          resolve();
          return;
        }
        const url = utils.getApiUrlV2(`trips/${userModel.item.id}/location_popup`);
        $http.get(url).then((response) => {
          this.response = response.data;
          resolve();
        });
      });

    },

    showModal: function () {
      if (admin.isAdmin()) {
        return;
      }

      var showModal = this.response.show;
      var MODAL_TYPE;

      if (!showModal || !userModel.item.location) {
        return;
      }

      if (userModel.item.location.placeId === null) {
        MODAL_TYPE = 'LOCATION_CONFIRMATION';
      } else {
        MODAL_TYPE = 'AUTOTRIP';
      }

      modal.open({
        template: `<sa-location-confirmation-modal type="${MODAL_TYPE}" name="${userModel.item.name}" on-success="close()">`,
        cssClass: 'LocationNotificationModal-modal Modal--sharpCorners',
        preventCloseWithESC: true
      });
    },
  };
}



// WEBPACK FOOTER //
// ./app/src/components/location_confirmation/location_confirmation_service.js